<script setup lang="ts">
import { computed } from 'vue';

import type { HotelDetailsEventSource } from '@apps/main/new-desktop/core/models';

import type {
  HotelDetailsFullscreenMasonryGalleryData,
  Stay,
  StayId,
} from '../../models';

import HotelStayDescription from './HotelStayDescription.vue';
import HotelStaySummary from './HotelStaySummary.vue';

interface HotelStayProps {
  stay: Stay;
  showSelectButton: boolean;
  source: HotelDetailsEventSource;
}
const props = defineProps<HotelStayProps>();

interface HotelStayEmits {
  (eventName: 'stay-selected', stayId: StayId): void;
  (eventName: 'more-information'): void;
  (
    eventName: 'open-gallery',
    data: HotelDetailsFullscreenMasonryGalleryData
  ): void;
}

const emit = defineEmits<HotelStayEmits>();

// TODO: Move this to store
// NOTE: This is here to help content team with room codes investigation
const roomCodesString = computed<string>(() =>
  props.stay.stayId.hotelRoomIds.map((id) => id.roomCode).join(' ; ')
);
</script>

<template>
  <div class="hotel-stay" :data-room-code="roomCodesString">
    <HotelStayDescription
      :stay="props.stay"
      :source="props.source"
      @more-information="emit('more-information')"
      @open-gallery="
        emit('open-gallery', {
          index: $event,
          images: props.stay.imagesURL,
        })
      "
    />
    <HotelStaySummary
      :stay="props.stay"
      :show-select-button="props.showSelectButton"
      @stay-selected="emit('stay-selected', $event)"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-stay {
  border-radius: var(--border-radius-8);
  padding: var(--spacing-16);
  background-color: var(--color-neutral-10);
  position: relative;

  display: flex;
  justify-content: space-between;
  gap: var(--spacing-40);

  @include for-less-or-equal-than-599-px {
    flex-direction: column;
  }
}
</style>
